/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

import { l } from '@atproto/lex'
import * as DraftDefs from './defs.defs.js'

const $nsid = 'app.bsky.draft.updateDraft'

export { $nsid }

/** Updates a draft using private storage (stash). If the draft ID points to a non-existing ID, the update will be silently ignored. This is done because updates don't enforce draft limit, so it accepts all writes, but will ignore invalid ones. Requires authentication. */
const main = l.procedure(
  $nsid,
  l.params(),
  l.jsonPayload({
    draft: l.ref<DraftDefs.DraftWithId>((() => DraftDefs.draftWithId) as any),
  }),
  l.payload(),
)
export { main }

export type $Params = l.InferMethodParams<typeof main>
export type $Input<B = l.BinaryData> = l.InferMethodInput<typeof main, B>
export type $InputBody<B = l.BinaryData> = l.InferMethodInputBody<
  typeof main,
  B
>
export type $Output<B = l.BinaryData> = l.InferMethodOutput<typeof main, B>
export type $OutputBody<B = l.BinaryData> = l.InferMethodOutputBody<
  typeof main,
  B
>

export const $lxm = main.nsid,
  $params = main.parameters,
  $input = main.input,
  $output = main.output
